import React from 'react';
import { Lightbulb } from 'lucide-react';
interface KeyInsightProps {
  children: React.ReactNode;
}
export function KeyInsight({
  children
}: KeyInsightProps) {
  return <div className="my-8 relative overflow-hidden rounded-r-xl border-l-4 border-gold bg-gold/10 p-6 md:p-8 shadow-sm" data-id="element-132">
      <div className="flex items-start gap-4" data-id="element-133">
        <div className="flex-shrink-0 mt-1" data-id="element-134">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold/20 text-gold" data-id="element-135">
            <Lightbulb className="h-5 w-5" data-id="element-136" />
          </div>
        </div>
        <div data-id="element-137">
          <h4 className="font-sans text-sm font-bold uppercase tracking-wider text-gold mb-2" data-id="element-138">
            Key Insight
          </h4>
          <div className="text-charcoal/90 font-serif italic text-lg leading-relaxed" data-id="element-139">
            {children}
          </div>
        </div>
      </div>
    </div>;
}